import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import MultiAppAuthentication from '../../components/MultiAppAuthentication';

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos, appInfos, galleryInfos: { config } } = state;
	const { accessibleApps, credentials, orgAuthMethods, form } = multiAppAuthenticationInfos;

	// userLocale is sent as a prop, to allow the rerendering of placeholders when the language is switched
	const { userLocale } = appInfos;

	return { accessibleApps, credentials, orgAuthMethods, login: form.login, userLocale, galleryConfig: config };
};

export default connect(mapStateToProps)(MultiAppAuthentication);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/index.tsx